export function barScanned (state, opened) {
  state.barscan = opened
}
